import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./productslisting.css";
import Button from "@mui/material/Button";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconOne from "../../assets/images/category-1.svg";

import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";

const ProductsListing = () => {
  const [isopenDropDown, setIsOpenDropDown] = useState(false);
  const [products, setProducts] = useState([]);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get("search");

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!query) return;

      try {
        const res = await fetch(`${baseURL}common/products_search/?search=${query}`);
        const data = await res.json();
        setProducts(data);
      } catch (err) {
        console.error("Search failed:", err);
      }
    };

    fetchSearchResults();
  }, [query]);

  return (
    <>
      <Header />
      <div className="product_listing">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 pt_20 mt_30">
              <div className="d_flex align_center justify_sp_between pr_20">
                <div className="heading_common mt_15">
                  <h3>Search Results for "{query}"</h3>
                </div>
                <div className="filter_box">
                  <div className="sort-dropdown" onClick={() => setIsOpenDropDown(!isopenDropDown)}>
                    <span className="arrow"><SwapVertIcon /></span>
                    <span>Sort by: Price</span>
                    <span className="arrow"><KeyboardArrowDownIcon /></span>
                  </div>
                  {isopenDropDown && (
                    <ClickAwayListener onClickAway={() => setIsOpenDropDown(false)}>
                      <div className="selectdropdown">
                        <ul>
                          <li><Button variant="text"><Link to="">Price: Low to High</Link></Button></li>
                          <li><Button variant="text"><Link to="">Price: High to Low</Link></Button></li>
                        </ul>
                      </div>
                    </ClickAwayListener>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="prod_list_grid">
                <div className="category-box">
                  <h4>Category</h4>
                  <div className="category-item"><Link to=""><div className="category-left"><img src={IconOne} alt="" /><span>Milks & Dairies</span></div></Link></div>
                  <div className="category-item"><Link to=""><div className="category-left"><img src={IconOne} alt="" /><span>Clothing</span></div></Link></div>
                  <div className="category-item"><Link to=""><div className="category-left"><img src={IconOne} alt="" /><span>Pet Foods</span></div></Link></div>
                  <div className="category-item"><Link to=""><div className="category-left"><img src={IconOne} alt="" /><span>Baking material</span></div></Link></div>
                  <div className="category-item"><Link to=""><div className="category-left"><img src={IconOne} alt="" /><span>Fresh Fruit</span></div></Link></div>
                </div>

                <div className="listing_products">
                         {products?.length > 0 ? (
                        products.map((product) => {
                          const variant = product.variants?.[0];
                          const imagePath = variant?.images?.[0]?.image;
                          
                          return (
                      <div key={product.id} className="product_card">
                        <img src={imagePath} alt={product.title} />
                        <h4>{product.title}</h4>
                        <p>₹{variant?.selling_price}</p>
                      </div>
                    )})
                  ) : (
                    <p>No products found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
};

export default ProductsListing;
